import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IDpdUkCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class DpdUkCredentialsStore implements ICredentialsStore {
    private _changes: IDpdUkCredentialsModel = {} as IDpdUkCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; };
    public get password() { return this._changes.password; };
    public get accountNumber() { return this._changes.account_number; };
    public get taxNumber() { return this._changes.tax_number; };
    public get eoriNumber() { return this._changes.eori_number; };
    public get pidNumber() { return this._changes.pid_number; };

    setUsername(value: string) {
        this._changes.username = value;
    };

    setPassword(value: string) {
        this._changes.password = value;
    };

    setAccountNumber(value: string) {
        this._changes.account_number = value;
    };

    setTaxNumber(value: string) {
        this._changes.tax_number = value;
    };

    setEoriNumber(value: string) {
        this._changes.eori_number = value;
    };

    setPidNumber(value: string) {
        this._changes.pid_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default DpdUkCredentialsStore;
